app.service('deliveryBadge', function (modal) {
	function init() {
		$('body').on('click', '.js-delivery-badge-info', function (e) {
			var id = $(this).data('delivery');
			modal.open('delivery-badge-' + id);
			e.preventDefault();
			e.stopPropagation();
		}).on('click', '.js-section-extend', function () {
			let $parent = $(this).parent();
			let expanded = $parent.attr('data-expanded') == 'true';
			$parent.attr('data-expanded', '' + !expanded);
		});
	}
	return {
		init
	};
});
